import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { LayoutsValuation } from '../../components/layoutsValuation';
import { useDispatch, useSelector } from 'react-redux';
import {
  advanceToStep,
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useEffect } from 'react';

export const LayoutsValuationSecondary: React.FC = () => {
  const { layoutsValuationSecondaryResponse, currentStep } =
    useSelector(studiesSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentProgressTo(3));
  }, []);
  return (
    <div className="layouts-valuation">
      <h6 className="layouts-valuation__title">
        {nls.studyCreationGuide.steps.step3.unitsValuation}
      </h6>
      {layoutsValuationSecondaryResponse ? (
        <LayoutsValuation
          valuationData={layoutsValuationSecondaryResponse}
          isPrimaryMarket={false}
        />
      ) : (
        <div className="study-creation-guide__buttons-container">
          <div>
            <ExitGuideButton />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <PreviousStepButton />
            <button
              className="btn normal primary"
              data-cy="StudyCreationGuideNextStep"
              type="button"
              onClick={() => dispatch(advanceToStep(currentStep.nextStep))}
            >
              {nls.studyCreationGuide.buttons.forward}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
